module.exports = __webpack_public_path__ + "static/typo logo1-93cc401cfb106bac979ab31b6d56ae7a.png";